module.exports = __webpack_public_path__ + "static/img/wisdomnew.4f0bb2f4.png";